// Whether an AudioCue waits for the learner's press. An explicit `manual` wins.
// Otherwise a sound list (deprecated) keeps its `autoplay` setting, a cue on the
// timeline starts with the scene (as it has since the timeline came), and one
// without keeps its pre-timeline `autoplay` setting.
export function audioCueManual(state, box) {
  if (typeof state?.manual === "boolean") return state.manual;
  if (Array.isArray(state?.soundList) && state.soundList.length > 0) return !state.autoplay;
  if (typeof box?.timeline?.startFrame === "number") return false;
  return !state?.autoplay;
}

// Writes each AudioCue's start as an explicit `manual` when content is loaded, so
// a timeline added later (legacy repair, a drag) cannot change how an old cue starts.
export function pinAudioCueStarts(toolbars, boxes) {
  let next = null;
  Object.keys(toolbars || {}).forEach((id) => {
    const tb = toolbars[id];
    if (tb?.pluginId !== "AudioCue" || !tb.state || typeof tb.state.manual === "boolean") return;
    next = next || { ...toolbars };
    next[id] = { ...tb, state: { ...tb.state, manual: audioCueManual(tb.state, boxes?.[id]) } };
  });
  return next || toolbars;
}
